const theme = {
	sidebar: {
		variant: {
			consignado: {
				textColor: 'white',
				titleFontSize: 'v_12',
				separatorLineColor: '#4865D9',
				backgroundColor: '#161D4A',
				backgroundActiveMenu: '#4865D9',
			},
		},
	},
};

export default theme;
